import { get_one_generic } from "./http_operations";
import { operationPages, pages, restrictionPages } from "../configManager";

//get and set the role definition
export async function SetRoleDefinition() {
  const role = localStorage.getItem("user-role");
  if (role === null || role === undefined || role === "") return;
  try {
    const response = await get_one_generic("roles", role);
    if (response !== undefined)
      localStorage.setItem("role", JSON.stringify(response.response.data));
  } catch (error) {
    console.error(error);
  }
}

//check if an user is allowed to do a specific action
//returns true if the use can perform the action, false otherwise
export function canDo(resource, actionCRUD, resourceUserId = undefined) {
  const tmpRole = localStorage.getItem("role");

  //DEPRECATED
  //if the role is not defined, use the hardcoded version
  //if (tmpRole === undefined || tmpRole === null)
  //  return canDoDeprecated(userRole, resource, actionCRUD);

  const _role = JSON.parse(tmpRole);
  const _id = localStorage.getItem("user-id");

  const isOwned = resourceUserId !== undefined ? resourceUserId === _id : true;

  if (_role?.isSystemAdministrator === true) return true;

  if (_role.actions.length !== 0) {
    const entityDef = _role.actions.find(
      (el) =>
        el.entity.toLowerCase() === resource.toLowerCase() ||
        el.entity.toLowerCase() + "s" === resource.toLowerCase()
    );
    if (entityDef === undefined)
      return (
        _role.default[actionCRUD] !== "none" &&
        _role.default[actionCRUD] !== false
      );

    if (entityDef !== undefined && entityDef.crud[actionCRUD] !== undefined) {
      if (entityDef.crud[actionCRUD] === "none") return false;
      if (entityDef.crud[actionCRUD] === true) return true;
      if (entityDef.crud[actionCRUD] === "owned") return isOwned;
      if (entityDef.crud[actionCRUD] === "all") return true;
    }
  }

  if (_role.default[actionCRUD] === undefined) return false;
  if (_role.default[actionCRUD] === "owned") return isOwned;
  if (_role.default[actionCRUD] === "all") return true;
  if (_role.default[actionCRUD] === "none") return false;
  if (_role.default[actionCRUD] === true) return true;
}

//deprecated check for user rights
function canDoDeprecated(userRole, resource, actionCRUD) {
  if (actionCRUD === "create") {
    if (userRole === "admin") return true;
    if (userRole === "provider") {
      if (resource === "users") return false;
      if (resource === "protocols") return false;
      if (resource === "experiments") return true;
    }
    if (userRole === "supplier") {
      if (resource === "users") return false;
      if (resource === "protocols") return false;
      if (resource === "experiments") return true;
    }
    if (userRole === "analyst") {
      if (resource === "users") return false;
      if (resource === "protocols") return false;
      if (resource === "experiments") return false;
    }
  }
  if (actionCRUD === "read") {
    if (userRole === "admin") return true;
    if (userRole === "provider") {
      if (resource === "users") return false;
      if (resource === "protocols") return false;
      if (resource === "experiments") return true;
    }
    if (userRole === "supplier") {
      if (resource === "users") return false;
      if (resource === "protocols") return false;
      if (resource === "experiments") return false;
    }
    if (userRole === "analyst") {
      if (resource === "users") return false;
      if (resource === "protocols") return false;
      if (resource === "experiments") return true;
    }
  }
  if (actionCRUD === "update") {
    if (userRole === "admin") return true;
    if (userRole === "provider") {
      if (resource === "users") return false;
      if (resource === "protocols") return false;
      if (resource === "experiments") return true;
    }
    if (userRole === "supplier") {
      if (resource === "users") return false;
      if (resource === "protocols") return false;
      if (resource === "experiments") return false;
    }
    if (userRole === "analyst") {
      if (resource === "users") return false;
      if (resource === "protocols") return false;
      if (resource === "experiments") return false;
    }
  }
  if (actionCRUD === "delete") {
    if (userRole === "admin") return true;
    if (userRole === "provider") {
      if (resource === "users") return false;
      if (resource === "protocols") return false;
      if (resource === "experiments") return true;
    }
    if (userRole === "supplier") {
      if (resource === "users") return false;
      if (resource === "protocols") return false;
      if (resource === "experiments") return false;
    }
    if (userRole === "analyst") {
      if (resource === "users") return false;
      if (resource === "protocols") return false;
      if (resource === "experiments") return false;
    }
  }
  return false;
}

export function AccessiblePages() {
  const role = localStorage.getItem("user-role");

  const accessibleResources = Object.keys(pages).filter(
    (k) =>
      canDo(k, "read") &&
      (restrictionPages[k] === undefined || restrictionPages[k].includes(role))
  );
  const accessibleOperations = operationPages.filter(
    (opPage) =>
      restrictionPages[opPage] === undefined ||
      restrictionPages[opPage].includes(role)
  );
  const accessibleList = accessibleResources.concat(accessibleOperations);
  const numAccessibleResources = accessibleResources.length;
  const numAccessibleOperations = accessibleOperations.length;
  const count = accessibleList.length;

  return {
    count,
    numAccessibleResources,
    numAccessibleOperations,
    accessibleResources,
    accessibleOperations,
    accessibleList,
  };
}
